import { DocumentType } from 'shared/data/walletsKyc/v1';

import { messages } from './usePersonDocumentTypes.messages';

export const documentTypeToMessage = {
    [DocumentType.bank_statement]: messages.bankStatement,
    [DocumentType.biometric_state_id]: messages.biometricStateId,
    [DocumentType.driving_licence]: messages.drivingLicence,
    [DocumentType.mortgage]: messages.mortgage,
    [DocumentType.passport]: messages.passport,
    [DocumentType.proof_of_business_activity]: messages.proofOfBusinessActivity,
    [DocumentType.proof_of_business_identity]: messages.proofOfBusinessIdentity,
    [DocumentType.proof_of_directors]: messages.proofOfDirectors,
    [DocumentType.proof_of_owners]: messages.proofOfOwners,
    [DocumentType.proof_of_source_of_funds]: messages.proofOfSourceOfFunds,
    [DocumentType.residence_id]: messages.residenceId,
    [DocumentType.state_id]: messages.stateId,
    [DocumentType.supporting]: messages.supporting,
    [DocumentType.unknown]: messages.unknown,
    [DocumentType.utility_bill]: messages.utilityBill,
    [DocumentType.visa]: messages.visa,
};

// https://approvalmax.atlassian.net/wiki/spaces/PAYMENTS/pages/3358064645/Persona#Persona-document-types
export const documentTypeToBackSide = {
    [DocumentType.bank_statement]: false,
    [DocumentType.biometric_state_id]: true,
    [DocumentType.driving_licence]: true,
    [DocumentType.mortgage]: false,
    [DocumentType.passport]: false,
    [DocumentType.proof_of_business_activity]: false,
    [DocumentType.proof_of_business_identity]: false,
    [DocumentType.proof_of_directors]: false,
    [DocumentType.proof_of_owners]: false,
    [DocumentType.proof_of_source_of_funds]: false,
    [DocumentType.residence_id]: true,
    [DocumentType.state_id]: true,
    [DocumentType.supporting]: false,
    [DocumentType.unknown]: false,
    [DocumentType.utility_bill]: false,
    [DocumentType.visa]: false,
};
